import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
	PRODUCT_ITEM: '[data-fragment="OrderFirstChoice.productsItem"]',
	PRODUCT_ITEM_INPUTS: '[data-fragment="OrderFirstChoice.productItemInput"]',
	CONTRACT_WRAP: '[data-fragment="OrderFirstChoice.contractWrap"]',
	CONTRACT: '[data-fragment="OrderFirstChoice.contract"]',
	CONTRACT_SELECT: '[data-fragment="OrderFirstChoice.contractSelect"]',
	CARD_ORDER: '[data-fragment="OrderFirstChoice.cardOrder"]',
	BUSINESS_CONDITIONS_INPUT: '[data-fragment="OrderFirstChoice.productItemBusinessConditionsInput"]',
};

class OrderFirstChoice extends WebComponent {
	constructor(props) {
		super(props);
		const {} = props;
	}

	didMount() {
		const {} = this.props;

		this.productItemElement = this.element.querySelectorAll(fragments.PRODUCT_ITEM);
		this.contractWrapElement = this.element.querySelector(fragments.CONTRACT_WRAP);
		this.contractElement = this.element.querySelector(fragments.CONTRACT);
		this.businessConditionsInput = this.element.querySelectorAll(fragments.BUSINESS_CONDITIONS_INPUT);

		this.initProducts();
		this.initContracts();
		this.initCardOrder();
		this.initContractSelect();
		if (this.productItemElement.length > 1) {
			this.on('click', fragments.PRODUCT_ITEM_INPUTS, this.initProducts);
		}
		if(this.businessConditionsInput.length > 0) {
			this.on('change', fragments.BUSINESS_CONDITIONS_INPUT, this.handleClickOnBusinessConditionsInput);
		}
		/* Inicializace smlouvy */
		this.element.addEventListener('afterContentsReplaced', () => {
			this.initContracts();
			this.initContractSelect();
		});
	}

	initCardOrder = () => {
		this.cardOrderElements = this.element.querySelectorAll(fragments.CARD_ORDER);
		if(this.cardOrderElements.length === 1) {
			setTimeout(() => {
					this.cardOrderElements[0].click();
			}, 200);
		}
	}

	handleClickOnBusinessConditionsInput = (e) => {
		let productsLinkElement = e.target.parentElement.parentElement.parentElement.querySelector('.products__link');
		if(productsLinkElement){
			let productsLinkElementHref = productsLinkElement.getAttribute('href');
			if(e.target.checked) {
				productsLinkElement.setAttribute('href', productsLinkElementHref.replace('conditionsAgreed=false', 'conditionsAgreed=true'));
			} else {
				productsLinkElement.setAttribute('href', productsLinkElementHref.replace('conditionsAgreed=true', 'conditionsAgreed=false'));
			}
		}
	}

	/* Nastaveni change listeneru na select smlouvy */
	initContractSelect = () => {
		$(this.element.querySelector(fragments.CONTRACT_SELECT)).on('change',(e) => {
			this.initContracts();
		});
	};

	/* Výběr produktů */
	initProducts = () => {
		let i;
		for (i = 0; i < this.productItemElement.length; i++) {
			let j;
			let productItemInputs = this.productItemElement[i].querySelectorAll('input[type=checkbox]:checked');
			if (productItemInputs.length === 0 && this.element.querySelectorAll('input[type=checkbox]:checked').length > 0) {
				this.productItemElement[i].classList.add('products__item--disabled');
				productItemInputs = this.productItemElement[i].querySelectorAll(fragments.PRODUCT_ITEM_INPUTS);
				for (j = 0; j < productItemInputs.length; j++) {
					productItemInputs[j].disabled = true;
				}
			} else {
				this.productItemElement[i].classList.remove('products__item--disabled');
				productItemInputs = this.productItemElement[i].querySelectorAll(fragments.PRODUCT_ITEM_INPUTS);
				for (j = 0; j < productItemInputs.length; j++) {
					productItemInputs[j].disabled = false;
				}
			}
		}
	};

	/* Výber smlouvy */
	initContracts = () => {
		let productChecked = this.element.querySelector('input[type=checkbox]:checked');
		if (productChecked != null) {
			const chooseContractElement = this.contractWrapElement.querySelector('select');
			let chooseContractElementSelectedId = chooseContractElement.options[chooseContractElement.selectedIndex].value;
			this.initProductOptionsPerContract(chooseContractElementSelectedId, productChecked);
			/* Skryje widget Vyber smlouvy, pokud je na vyber pouze jedna */
			let productContractElement = productChecked.parentElement.parentElement.parentElement.querySelector('.products__contract');
			productContractElement.appendChild(this.contractWrapElement);
		}
	};

	/* Provede dotaz, jake jsou moznosti typů per smlouvu */
	initProductOptionsPerContract = (contractId, productChecked) => {
		let productOptions = productChecked.parentElement.parentElement;
		let productOptionsCheckbox = productOptions.querySelectorAll('input[type=checkbox]');
		let _self = this;
		if(contractId != null) {
			$.ajax({
				type: "POST",
				url: '/contractedProductVariantService?contractId='+contractId+'&productId='+productChecked.value+'&eventName.checkProducts:checkProducts=',
				success: function (data) {
					let associatedProductId = data['associatedProductId'];
					for(let i = 0; i < productOptionsCheckbox.length; i++) {
						productOptionsCheckbox[i].disabled = associatedProductId == null && productOptionsCheckbox[i].checked === false;
					}
					_self.initChooseContractElement();
				}
			});
		}
	};

	/* Zobrazi - Skryje widget smlouvy */
	initChooseContractElement = () => {
		if (this.element.querySelector(fragments.CONTRACT_SELECT).length > 1) {
			this.contractWrapElement.classList.remove('hidden');
		} else {
			this.contractWrapElement.classList.add('hidden');
		}
	};

}

export default OrderFirstChoice;



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/Orders/OrderFirstChoice.js